export default class OneTimeCashStore {
  static data = {
    amount: null,
    predefinedAmount: "",
    serverErrors: "",
  }

  static cleanServerErrors() {
    this.data.serverErrors = "";
  }
}
